<template>
  <v-row 
    no-gutters 
    class="thickness-map image-with-palette" 
    :class="{'has-palette': isMultiview || hasPalette}">
    <v-col :id="mapId" class="thickness-map-wrapper image">
      <image-not-found v-if="imgNotFound" />
      <pixel-shaded-canvas
        :img="img"
        :imgSize="size"
        :canvasSize="size"
        :thicknessMapColorSettings="colorSettings"/>
      <canvas-annotation v-if="showETDRS" :canvasSize="size" :annotation="etdrs" />
      <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
    </v-col>
    <v-col cols="auto" 
      v-if="hasPalette" 
      class="thickness-map-palette-wrapper palette" 
      :id="paletteId">
      <canvas-annotation
        :canvasSize="paletteSize"
        :imgSize="paletteSize"
        :annotation="paletteAnnotation"/>
    </v-col>
  </v-row>
</template>

<script>
import pixelShadedCanvas from "../../../canvas/components/PixelShadedCanvas";
import canvasAnnotation from "../../../canvas/components/CanvasAnnotation";
import ThicknessMapPalette from "../../../canvas/annotations/thicknessMapPalette";
import AnalysisETDRS from "../../../canvas/annotations/analysisETDRS";
import imageNotFound from "../../misc/ImageNotFound";
export default {
  name: "thicknessMap",
  components: { pixelShadedCanvas, canvasAnnotation, imageNotFound },
  props: {
    mapId: { type: String, default: "thickness-map-wrapper" },
    paletteId: { type: String, default: "thickness-map-palette-wrapper" },
    img: HTMLImageElement,
    size: Object,
    colorSettings: Object,
    palette: Array,
    paletteSize: Object,
    minThickness: Number,
    maxThickness: Number,
    thicknessStep: Number,
    isLoading: Boolean,
    imgNotFound: Boolean,
    showETDRS: Boolean,
    foveaOffset: Object,
    thicknessAnalysis: Object,
    isMultiview: Boolean
  },
  data() {
    return {
      paletteAnnotation: new ThicknessMapPalette(),
      etdrs: new AnalysisETDRS("white", "white")
    };
  },
  computed: {
    hasPalette() {
      return this.palette && this.palette.length;
    }
  },
  watch: {
    palette() {
      this.paletteAnnotation.updateGradient(this.palette);
    },
    minThickness() {
      this.paletteAnnotation.thicknessMapMinThicknessUm = this.minThickness;
    },
    maxThickness() {
      this.paletteAnnotation.thicknessMapMaxThicknessUm = this.maxThickness;
    },
    thicknessStep() {
      this.paletteAnnotation.thicknessMapThicknessStepUm = this.thicknessStep;
    },
    foveaOffset() {
      this.etdrs.updateFoveaOffset(this.foveaOffset);
    },
    thicknessAnalysis() {
      this.etdrs.updateThicknessAnalysis(this.thicknessAnalysis);
    }
  },
  mounted() {
    this.paletteAnnotation.updateGradient(this.palette);
    this.paletteAnnotation.thicknessMapMinThicknessUm = this.minThickness;
    this.paletteAnnotation.thicknessMapMaxThicknessUm = this.maxThickness;
    this.paletteAnnotation.thicknessMapThicknessStepUm = this.thicknessStep;
    this.etdrs.updateFoveaOffset(this.foveaOffset);
    this.etdrs.updateThicknessAnalysis(this.thicknessAnalysis);
  }
};
</script>

<style lang="scss" scoped>
.thickness-map ::v-deep {
  height: 100%;

  .thickness-map-wrapper {
    height: 100%;
    position: relative;
  }

  .thickness-map-palette-wrapper {
    height: 100%;
    position: relative;
  }
}
</style>
